import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRedo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.5 11.4995L9.5 11.4995C7.29086 11.4995 5.5 13.2904 5.5 15.4995L5.5 17M18.5 11.4995L13.5 6.5M18.5 11.4995L13.4995 16.5",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRedo;
